<template>
  <div class="courses-container">
    <el-card>
      <template #header>
        <span>课程管理</span>
      </template>

      <!-- 添加课程 -->
      <el-card style="margin-bottom: 20px;">
        <div style="font-weight: bold; margin-bottom: 10px;">添加课程</div>
        <image-upload v-model="form.course_url" style="margin-bottom: 10px;" />
        <el-input v-model="form.course_name" placeholder="请输入课程名称" style="margin-bottom: 10px; width: 300px;" />
        <el-input v-model="form.course_level" placeholder="请输入课程等级" style="margin-bottom: 10px; width: 300px;" />
        <el-input v-model="form.course_content" type="textarea" :rows="2" placeholder="请输入课程简介" style="margin-bottom: 10px; width: 400px;" />
        <el-button type="primary" @click="submitCourse">添加课程</el-button>
      </el-card>

      <!-- 拖拽课程列表 -->
      <draggable v-model="courseList" handle=".drag-handle" @end="onDragEnd">
        <transition-group>
          <el-card
              v-for="course in courseList"
              :key="course.id"
              class="course-card"
              style="margin-bottom: 12px;"
          >
            <div class="course-item">
              <span class="drag-handle">☰</span>
              <img :src="course.course_url" alt="cover" class="course-thumbnail" />
              <div class="course-info">
                <div class="course-name">课程名称：{{ course.course_name }}</div>
                <div class="course-level">等级：{{ course.course_level }}</div>
                <div class="course-description" v-html="$formatTextWithLineBreaks(course.course_content)" />
                <div class="course-labels">
                  <el-tag
                      v-for="(label, index) in course.label_names"
                      :key="index"
                      size="small"
                  >{{ label }}</el-tag>
                </div>
              </div>
              <div class="course-actions">
                <el-button size="mini" @click="handleEditCourse(course)">编辑</el-button>
                <el-button size="mini" type="success" @click="handleEditLabels(course)">标签</el-button>
                <el-button size="mini" type="danger" @click="handleDeleteCourse(course)">删除</el-button>
              </div>
            </div>
          </el-card>
        </transition-group>
      </draggable>

      <!-- 编辑课程弹窗 -->
      <el-dialog :title="'编辑课程'" :visible.sync="editDialog" width="500px">
        <el-form :model="editForm" label-width="80px">
          <el-form-item label="封面">
            <image-upload v-model="editForm.course_url" />
          </el-form-item>
          <el-form-item label="名称">
            <el-input v-model="editForm.course_name" />
          </el-form-item>
          <el-form-item label="等级">
            <el-input v-model="editForm.course_level" />
          </el-form-item>
          <el-form-item label="简介">
            <el-input type="textarea" v-model="editForm.course_content" :rows="2" />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="editDialog = false">取消</el-button>
          <el-button type="primary" @click="submitEditCourse">保存</el-button>
        </template>
      </el-dialog>

      <!-- 编辑标签弹窗 -->
      <el-dialog :title="'编辑标签'" :visible.sync="editLabelDialog" width="400px">
        <el-form :model="labelForm" label-width="60px">
          <el-form-item label="标签">
            <el-input v-model="labelForm.label_names_str" placeholder="多个标签用英文逗号分隔" />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="editLabelDialog = false">取消</el-button>
          <el-button type="primary" @click="submitEditLabels">保存</el-button>
        </template>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload.vue'
import {
  getCourses,
  createCourse,
  updateCourse,
  deleteCourse,
  updateCourseLabels,
  updateCourseOrder
} from '@/api/course'
import draggable from 'vuedraggable'

export default {
  name: 'AdminCourses',
  components: {ImageUpload, draggable},
  data() {
    return {
      form: {
        course_url: '',
        course_name: '',
        course_level: '',
        course_content: ''
      },
      courseList: [],
      editDialog: false,
      editForm: {
        id: '',
        course_url: '',
        course_name: '',
        course_level: '',
        course_content: ''
      },
      editLabelDialog: false,
      labelForm: {
        course_id: '',
        label_names_str: ''
      }
    }
  },
  created() {
    this.fetchCourseList()
  },
  methods: {
    async fetchCourseList() {
      try {
        const res = await getCourses()
        this.courseList = Array.isArray(res)
            ? res.map(item => ({
              id: item.id,
              course_name: item.course_name,
              course_level: item.course_level,
              course_url: item.course_url || '',
              course_content: item.course_content,
              label_names: (item.course_labels || []).map(l => l.label_name)
            }))
            : []
      } catch (e) {
        this.courseList = []
      }
    },
    parseLabels(str) {
      return str.split(',').map(v => v.trim()).filter(v => v)
    },
    async submitCourse() {
      if (!this.form.course_name || !this.form.course_content) {
        this.$message.error('请填写完整信息')
        return
      }
      try {
        await createCourse(this.form)
        this.$message.success('课程添加成功')
        this.form = {
          course_url: '',
          course_name: '',
          course_level: '',
          course_content: ''
        }
        this.fetchCourseList()
      } catch (e) {
        this.$message.error('添加失败')
      }
    },
    handleEditCourse(row) {
      this.editForm = {...row}
      this.editDialog = true
    },
    async submitEditCourse() {
      try {
        await updateCourse(this.editForm.id, this.editForm)
        this.$message.success('保存成功')
        this.editDialog = false
        this.fetchCourseList()
      } catch (e) {
        this.$message.error('保存失败')
      }
    },
    handleEditLabels(row) {
      this.labelForm.course_id = row.id
      this.labelForm.label_names_str = (row.label_names || []).join(', ')
      this.editLabelDialog = true
    },
    async submitEditLabels() {
      const labels = this.parseLabels(this.labelForm.label_names_str)
      try {
        await updateCourseLabels({
          course_id: this.labelForm.course_id,
          label_names: labels
        })
        this.$message.success('标签更新成功')
        this.editLabelDialog = false
        this.fetchCourseList()
      } catch (e) {
        this.$message.error('更新失败')
      }
    },
    async handleDeleteCourse(row) {
      this.$confirm('确认删除该课程吗？', '提示', {type: 'warning'})
          .then(async () => {
            await deleteCourse(row.id)
            this.$message.success('删除成功')
            this.fetchCourseList()
          })
          .catch(() => {
          })
    },
    async onDragEnd() {
      try {
        const course_ids = this.courseList.map(course => course.id)
        await updateCourseOrder({course_ids})
        this.$message.success('课程排序已更新')
      } catch (e) {
        this.$message.error('更新排序失败')
      }
    }
  }
}
</script>

<style scoped>
.courses-container {
  padding: 20px;
}

.course-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s;
}

.course-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.course-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.course-thumbnail {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
}

.course-info {
  flex-grow: 1;
}

.course-name {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 4px;
  color: #303133;
}

.course-level {
  color: #909399;
  font-size: 13px;
  margin-bottom: 6px;
}

.course-description {
  font-size: 13px;
  color: #606266;
  overflow: hidden;
  line-height: 1.4;
  margin-bottom: 4px;
}

.course-labels {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 6px;
}

.course-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-left: 10px;
}

.drag-handle {
  cursor: grab;
  color: #999;
  user-select: none;
  font-size: 18px;
  margin-right: 8px;
}
</style>
